export function getCardImageUrl(card: { tcgplayer_id: string | null }) {
  return `https://product-images.tcgplayer.com/fit-in/437x610/filters:quality(95)/${card.tcgplayer_id}.jpg`;
}
